module.exports = __webpack_public_path__ + "img/组 223.bc6cdd74.png";